import { Injectable } from '@angular/core';
import { UserCompanyControllerClient } from '../../../shared/api/ph-web/user/user.apiServiceClientPb';
import { environment } from 'src/environments/environment';
import { GrpcFactoryService } from '../../sharedServices/grpc-factory.service';
import { MuException } from '../../types/exception.type';
import {
  ValidatePhoneRequest,
  SendVerificationCodeRequest,
  ValidateVerificationCodeRequest,
  StatusInfo,
} from '../../../shared/api/ph-web/user/user.api_pb';

@Injectable({
  providedIn: 'root',
})
export class MuSmsService {
  private userCompanyClient = this.grpcFactoryService.create(
    UserCompanyControllerClient,
    `${environment.hostname}${environment.hostPort}`,
    'UserCompanyControllerClient'
  );

  private validatePhoneCall = this.grpcFactoryService.call(this.userCompanyClient, this.userCompanyClient.validatePhone, {
    callName: 'validatePhone',
  });
  private sendVerificationCodeCall = this.grpcFactoryService.call(this.userCompanyClient, this.userCompanyClient.sendVerificationCode, {
    callName: 'sendVerificationCode',
  });
  private validateVerificationCodeCall = this.grpcFactoryService.call(
    this.userCompanyClient,
    this.userCompanyClient.validateVerificationCode,
    {
      callName: 'validateVerificationCode',
    }
  );

  constructor(private grpcFactoryService: GrpcFactoryService) {
    /** */
  }

  /**
   * method to validate phone
   *
   * @param {number} phone
   * @return {*}  {Promise<void>}
   * @memberof AuthService.validatePhone
   */
  async validatePhone(phone: number): Promise<void> {
    const validatePhoneRequest = new ValidatePhoneRequest();

    validatePhoneRequest.setPhone(phone);

    const response = await this.validatePhoneCall(validatePhoneRequest);
    if (response.getStatus().getStatus() !== StatusInfo.StatusType.SUCCESS) {
      throw new MuException({ code: 3, key: 'assigned', message: response?.getStatus()?.getMessage() });
    }
  }

  /**
   * method to send opt
   *
   * @param {number} countryId
   * @param {number} phone
   * @return {*}  {Promise<void>}
   * @memberof AuthService.sendVerificationCode
   */
  async sendVerificationCode(countryId: number, phone: number): Promise<string> {
    const sendVerificationCodeRequest = new SendVerificationCodeRequest();

    sendVerificationCodeRequest.setCountryid(countryId);
    sendVerificationCodeRequest.setPhone(phone);

    const response = await this.sendVerificationCodeCall(sendVerificationCodeRequest);

    if (response.getStatusinfo().getStatus() !== StatusInfo.StatusType.SUCCESS) {
      throw new MuException({ message: response?.getStatusinfo()?.getMessage() });
    }
    return response?.getStatusinfo()?.getMessage();
  }

  /**
   * method to validate code verifcation
   *
   * @param {number} countryID
   * @param {number} phone
   * @param {number} code
   * @return {*}  {Promise<boolean>}
   * @memberof AuthService.validateVerificationCode
   */
  async validateVerificationCode(countryID: number, phone: number, code: number): Promise<boolean> {
    const request = new ValidateVerificationCodeRequest();

    request.setCountryid(countryID);
    request.setPhone(phone);
    request.setCode(code);

    const response = await this.validateVerificationCodeCall(request);

    if (response.getStatusinfo().getStatus() !== StatusInfo.StatusType.SUCCESS || !response.getIsvalid()) {
      throw new MuException({ message: response?.getStatusinfo()?.getMessage() });
    }
    return response.getIsvalid();
  }
}
